module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kf-Lc.4009ddd2.png";